import type { DocumentIntelligence } from "@structurify/shared-types";

const API_URL = (import.meta.env["VITE_API_URL"] as string | undefined) ?? "https://api.structurify.dscvry.ai";

export interface UploadInitResponse {
  documentId: string;
  uploadUrl: string;
  token: string;
}

export interface ExtractedField {
  name: string;
  label: string;
  value: string;
  type: string;
  confidence: number;
  source?: string;
}

export interface DocumentStatus {
  documentId: string;
  status: string;
  documentType: string | null;
  fields: ExtractedField[] | null;
  intelligence: DocumentIntelligence | null;
  error: string | null;
}

export async function initUpload(file: File, session?: string | undefined, workflowId?: string | undefined): Promise<UploadInitResponse> {
  const headers: Record<string, string> = { "Content-Type": "application/json" };
  if (session) headers["Authorization"] = `Bearer ${session}`;
  const res = await fetch(`${API_URL}/api/upload/init`, {
    method: "POST",
    headers,
    body: JSON.stringify({ name: file.name, size: file.size, mimeType: file.type, workflowId }),
  });
  if (!res.ok) throw new Error(`Init failed: ${res.status}`);
  return res.json() as Promise<UploadInitResponse>;
}

export async function putFile(uploadUrl: string, token: string, file: File): Promise<void> {
  const url = uploadUrl.startsWith("/") ? `${API_URL}${uploadUrl}` : uploadUrl;
  const res = await fetch(url, {
    method: "PUT",
    headers: { "X-Upload-Token": token, "Content-Type": file.type },
    body: file,
  });
  if (!res.ok) throw new Error(`Upload failed: ${res.status}`);
}

export async function getDocumentStatus(documentId: string): Promise<DocumentStatus> {
  const res = await fetch(`${API_URL}/api/documents/${documentId}`);
  if (!res.ok) throw new Error(`Status check failed: ${res.status}`);
  return res.json() as Promise<DocumentStatus>;
}
